module.exports = "https://cdn.thelire.com/ins/resource/fa_place_n@3x.d8f116299b3f073daae471f23258f2fd.png";